import { vars } from 'src/core/themes';

import { PosIconProps, SvgWrapper } from '../SvgWrapper';

export const MezzanineIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4149 17.7875C33.6701 16.4267 32.921 15.066 31.5954 14.6665C27.9089 13.5555 23.8103 13 20.0001 13C16.1899 13 12.0912 13.5555 8.40476 14.6665C7.07915 15.066 6.33008 16.4267 6.58523 17.7875C6.90817 19.5098 8.68629 20.5397 10.3902 20.1305C13.5282 19.3768 16.862 19 20.0001 19C23.1382 19 26.4719 19.3768 29.6099 20.1305C31.3138 20.5397 33.092 19.5098 33.4149 17.7875Z"
        fill={vars.color.textPrimaryV2}
      />
      <path
        d="M26.7116 34.9929C28.4692 35.4616 30.2988 34.4069 30.634 32.619L31.7563 26.6336C32.0209 25.2222 31.2516 23.807 29.8746 23.3997C26.7199 22.4666 23.2408 22 20.0001 22C16.7594 22 13.2802 22.4666 10.1256 23.3997C8.74855 23.807 7.97923 25.2222 8.24387 26.6336L9.36614 32.619C9.70136 34.4069 11.531 35.4616 13.2886 34.9929C15.2459 34.4709 17.623 34 20.0001 34C22.3772 34 24.7542 34.4709 26.7116 34.9929Z"
        fill={vars.color.textSecondaryV2}
      />
      <path
        d="M19.9996 4.00024C15.5583 4.00024 10.7252 4.755 6.60965 6.26452C5.39842 6.70879 4.74728 7.98805 4.98504 9.25609C5.31334 11.0071 7.16941 12.016 8.88233 11.5265C12.4429 10.509 16.3534 10.0002 19.9997 10.0002C23.6459 10.0002 27.5563 10.509 31.1169 11.5264C32.8298 12.0159 34.6858 11.007 35.0141 9.25607C35.2518 7.98805 34.6007 6.70879 33.3895 6.26453C29.274 4.75501 24.4408 4.00024 19.9996 4.00024Z"
        fill={vars.color.textSecondaryV2}
      />
    </SvgWrapper>
  );
};
